import { connect } from "react-redux";

import { withRouter } from "react-router-dom";
import { ROLE_TYPES } from "../../../helpers/roleTypes";
import ManageChangeSignatory from "./ManageChangeSignatory";

const ManageChangeSignatoryContainer = ({ loggedInUser }) => {
  return (
    <div>
      {loggedInUser.roleTypes.includes(ROLE_TYPES.FINANCE) && (
        <ManageChangeSignatory />
      )}
    </div>
  );
};
const mapStateToProps = (state) => {
  const { loggedInUser } = state.authReducer;

  return {
    loggedInUser,
  };
};
// export default ManageChangeSignatoryContainer
export default withRouter(
  connect(mapStateToProps)(ManageChangeSignatoryContainer)
);
